import { render, staticRenderFns } from "./prozis-logo.component.vue?vue&type=template&id=aec92986&scoped=true&"
import script from "./prozis-logo.component.vue?vue&type=script&lang=ts&"
export * from "./prozis-logo.component.vue?vue&type=script&lang=ts&"
import style0 from "./prozis-logo.component.vue?vue&type=style&index=0&id=aec92986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec92986",
  null
  
)

export default component.exports